import React from 'react';
import Row from '@prism/row';

class PrismRow extends React.PureComponent {
    render() {
        return <Row className="prism-row">{this.props.children}</Row>;
    }
}

export default PrismRow;
